import React from 'react'

import { FeedbackScreen } from '@interco/inter-toranja'
import { BridgeService } from '@/services'
import { TagProps } from '@interco/inter-toranja/dist/types/shared'
import { Header } from '@/components'

import * as S from './styles'

export const FeedbackAgeRestriction = () => {
  const handleClick = () => {
    BridgeService.requestGoBack()
  }

  const handleTag = (tag: TagProps) => {
    const result = tag({
      screen_name: 'HomeCredit: Emprestimo',
      title: 'Produto indisponível para menores de idade',
    }) as AnalyticsEvent

    BridgeService.requestAnalytics('CREDITO_ACESSO', {
      screen_name: result.screen_name,
      component_name: result.ComponentProperties.component_name,
      hierarchy: result.ComponentProperties.hierarchy,
      label: result.ComponentProperties.label,
      leading_icon: result.ComponentProperties.leading_icon,
      show_leading_icon: String(result.ComponentProperties.show_leading_icon),
      size: result.ComponentProperties.size,
      state: result.ComponentProperties.state,
      variant: result.ComponentProperties.variant,
    })
  }

  return (
    <S.Container>
      <Header showLeftIcon={false} onBackClick={handleClick} />
      <FeedbackScreen
        title="Produto indisponível para menores de idade"
        description="Este produto é exclusivo para maiores de 18 anos e não pode ser acessado."
        variant="custom"
        primaryButton={{ label: 'Voltar pra Home', onClick: handleClick, onTag: handleTag }}
      />
    </S.Container>
  )
}
